import React from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

const SLIDES = [
  '/assets/images/bali.png',
  '/assets/images/goa.png',
  '/assets/images/new_york.png',
  '/assets/images/tokyo.png',
];

function TourCard({ className = '' }) {
  return (
    <div className={`relative overflow-hidden bg-zinc-950 ${className}`}>
      <Swiper
        modules={[Pagination, Autoplay]}
        className="h-full w-full"
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
          el: '.register-swiper-pagination',
          bulletClass:
            'swiper-pagination-bullet !w-2 !h-2 !mx-1 !inline-block !rounded-full !bg-white/40 !opacity-100',
          bulletActiveClass: 'swiper-pagination-bullet-active !bg-orange-500 !w-6',
        }}
      >
        {SLIDES.map((slide, index) => (
          <SwiperSlide key={slide}>
            <img
              loading="lazy"
              src={slide}
              className="h-full w-full object-cover"
              alt={`Travel destination ${index + 1}`}
            />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-zinc-900/80 via-transparent to-zinc-900/20" />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="register-swiper-pagination absolute bottom-5 left-0 right-0 z-10 flex justify-center" />
    </div>
  );
}

TourCard.propTypes = {
  className: PropTypes.string,
};

export default TourCard;
